export type AdZoneKey = "banner" | "sidebar" | "footer";

export interface AdZoneCard {
  image_url: string | null;
  title: string;
  cta_label: string;
  cta_url: string;
}

export interface AdZone {
  id: string;
  zone_key: AdZoneKey;
  title: string;
  description: string;
  image_url: string | null;
  cta_label: string | null;
  cta_url: string | null;
  cards: AdZoneCard[] | null;
  is_active: boolean;
  updated_at: string;
  updated_by: string | null;
}

export interface AdZoneFormData {
  title: string;
  description: string;
  image_url: string | null;
  cta_label: string;
  cta_url: string;
  cards?: AdZoneCard[];
  is_active: boolean;
}

import { createEmptyFooterCards, FOOTER_GUIDES_SECTION_TITLE } from "@/utils/adZoneFooterUtils";

export const AD_ZONE_LABELS: Record<AdZoneKey, string> = {
  banner: "Bannière (sous le header)",
  sidebar: "Sidebar (colonne gauche)",
  footer: "Pied de page — Guides pratiques (4 cartes)",
};

export const DEFAULT_AD_ZONES: Record<AdZoneKey, AdZoneFormData> = {
  banner: {
    title: "",
    description: "",
    image_url: null,
    cta_label: "",
    cta_url: "",
    is_active: false,
  },
  footer: {
    title: FOOTER_GUIDES_SECTION_TITLE,
    description: "",
    image_url: null,
    cta_label: "",
    cta_url: "",
    cards: [
      {
        image_url: "/images/alunatools/7b0f066c-1d98-4cd3-90a0-ecf558767375.png",
        title: "Vendre sur le web, par où commencer ?",
        cta_label: "Télécharger gratuitement",
        cta_url: "https://barbara-raux.systeme.io/accueil",
      },
      ...createEmptyFooterCards(3),
    ],
    is_active: true,
  },
  sidebar: {
    title: "",
    description: "",
    image_url: null,
    cta_label: "",
    cta_url: "",
    is_active: false,
  },
};
